import {combineReducers} from 'redux';

import authenticationAgencyReducers from './authenticationAgencyReducers.js';
import authenticationReducers from './authenticationReducers.js';
import cartReducers from './cartReducers.js';
import cruiseReducers from './cruisesReducers';
import bookingsReducers from './bookingsReducers';
import paymentReducers from './paymentReducers';
import storeReducers from './storeReducers';
import itineraryReducers from './itineraryReducers';
import locationReducers from './locationReducers';
import tagsReducres from "./tagsReducres";
import preCruiseReducers from "./preCruiseReducers";
import tacReducers from "./tacReducers";

const allReducers = combineReducers({
    agency: authenticationAgencyReducers,
    authentication: authenticationReducers,
    bookings: bookingsReducers,
    cart: cartReducers,
    cruises: cruiseReducers,
    itinerary: itineraryReducers,
    location: locationReducers,
    payment: paymentReducers,
    preCruise: preCruiseReducers,
    store: storeReducers,
    tac: tacReducers,
    tags: tagsReducres,
});

export default allReducers;